(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-salon"] && !Shopify.designMode) return;
  try {
    
/* Nitka — Collection "Salon" section behaviour (no dependencies) */
(() => {
  if (customElements.get('nc-collection')) return;

  const clean = (s) => String(s || '').replace(/<[^>]*>/g, '').replace(/[ \t\u00a0]+/g, ' ').replace(/ *\n */g, '\n').replace(/\n{3,}/g, '\n\n').trim();

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || ('$' + '{' + '{amount}' + '}');
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const kind = m ? m[1] : 'amount';
    const withDelims = (n, p, t, d) => {
      n = (n / 100).toFixed(p);
      const [a, b] = n.split('.');
      return a.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (b ? d + b : '');
    };
    const map = {
      amount: () => withDelims(cents, 2, ',', '.'),
      amount_no_decimals: () => withDelims(cents, 0, ',', '.'),
      amount_with_comma_separator: () => withDelims(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => withDelims(cents, 0, '.', ','),
      amount_with_apostrophe_separator: () => withDelims(cents, 2, "'", '.'),
      amount_no_decimals_with_space_separator: () => withDelims(cents, 0, ' ', ''),
      amount_with_space_separator: () => withDelims(cents, 2, ' ', ','),
      amount_with_period_and_space_separator: () => withDelims(cents, 2, ' ', '.')
    };
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, (map[kind] || map.amount)());
  }
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  class NcCollection extends HTMLElement {
    connectedCallback() {
      this.sid = this.dataset.sectionId;
      this.labels = {};
      try { this.labels = JSON.parse(this.querySelector('[data-nc-labels]').innerHTML); } catch (e) {}
      this.scrim = this.querySelector('[data-nc-scrim]');
      this.modal = this.querySelector('[data-nc-modal]');
      this.chat = this.querySelector('[data-nc-chat-panel]');
      this.toastEl = this.querySelector('[data-nc-toast]');
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('input', this.onInput.bind(this));
      this.addEventListener('scroll', (e) => {
        if (!e.target.matches) return;
        if (e.target.matches('[data-nc-track]')) this.syncArrows(e.target);
        if (e.target.matches('[data-nc-lb-track]')) this.syncLb();
      }, true);
      window.addEventListener('resize', () => this.syncLb());
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeAll(); });
      window.addEventListener('popstate', () => this.refresh(location.href, false));
      this.initBody();
    }

    /* ---------- body (re-run after every AJAX refresh) ---------- */
    initBody() {
      this.body = this.querySelector('[data-nc-body]');
      this.form = this.querySelector('[data-nc-form]');
      this.drawer = this.querySelector('[data-nc-drawer]');
      this.mbar = this.querySelector('.nc-mbar');
      this.observeSentinel();
      this.observeFooter();
      this.syncLb();
    }

    syncLb() {
      const t = this.querySelector('[data-nc-lb-track]');
      const ar = this.querySelector('.nc-lb__ar');
      if (!t || !ar) return;
      const max = t.scrollWidth - t.clientWidth - 2;
      ar.hidden = max <= 0;
      const [prev, next] = ar.querySelectorAll('button');
      prev.disabled = t.scrollLeft <= 2;
      next.disabled = t.scrollLeft >= max;
    }

    observeSentinel() {
      if (this.io) this.io.disconnect();
      const s = this.querySelector('[data-nc-sentinel]');
      if (!s) return;
      this.io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) { this.io.disconnect(); this.loadMore(s.dataset.ncNext, s); }
      }, { rootMargin: '400px 0px' });
      this.io.observe(s);
    }

    observeFooter() {
      // hide the floating mobile Filter/Sort pill when the footer or description is in view
      if (this.fo) this.fo.disconnect();
      const target = this.querySelector('.nc-seo') || this.querySelector('[data-nc-foot]');
      if (!target || !this.mbar) return;
      this.fo = new IntersectionObserver((e) => this.mbar.classList.toggle('is-hidden', e[0].isIntersecting), { rootMargin: '0px 0px -40px 0px' });
      this.fo.observe(target);
    }

    /* ---------- events ---------- */
    onClick(e) {
      const t = e.target.closest('[data-nc-close],[data-nc-open],[data-nc-scrim],[data-nc-link],[data-nc-more],[data-nc-qv],[data-nc-chat],[data-nc-mirror],[data-nc-size],[data-nc-add],[data-nc-slide],[data-nc-lb],.nc-pg a');
      if (!t || !this.contains(t)) return;
      if (t.matches('[data-nc-lb]')) {
        const lt = this.querySelector('[data-nc-lb-track]');
        if (lt) lt.scrollBy({ left: Number(t.dataset.ncLb) * lt.clientWidth * 0.8, behavior: 'smooth' });
        return;
      }
      if (t.matches('[data-nc-slide]')) {
        e.preventDefault(); e.stopPropagation();
        const track = t.parentElement.querySelector('[data-nc-track]');
        if (track) track.scrollBy({ left: Number(t.dataset.ncSlide) * track.clientWidth, behavior: 'smooth' });
        return;
      }
      if (t.matches('[data-nc-close],[data-nc-scrim]')) { e.preventDefault(); this.closeAll(); return; }
      if (t.matches('[data-nc-open]')) { this.open(this.drawer); return; }
      if (t.matches('[data-nc-link]')) { e.preventDefault(); this.refresh(t.href); return; }
      if (t.matches('[data-nc-more]')) { e.preventDefault(); this.loadMore(t.dataset.ncNext, t); return; }
      if (t.matches('[data-nc-qv]')) { e.preventDefault(); this.quickView(t.dataset.ncQv); return; }
      if (t.matches('[data-nc-chat]')) { e.preventDefault(); this.openChat(t.dataset.ncChat || ''); return; }
      if (t.matches('[data-nc-mirror]')) {
        e.preventDefault();
        const input = this.querySelector('#' + CSS.escape(t.dataset.ncMirror));
        if (input && !input.disabled) {
          input.checked = !input.checked;
          t.classList.toggle('is-on', input.checked);
          t.setAttribute('aria-pressed', input.checked);
          this.submitFilters();
        }
        return;
      }
      if (t.matches('[data-nc-size]')) { this.pickSize(t); return; }
      if (t.matches('[data-nc-add]')) { e.preventDefault(); this.addToCart(t); return; }
    }

    onChange(e) {
      const el = e.target;
      if (el.matches('[data-nc-sort]') || el.matches('[data-nc-sort-radio]')) {
        this.form.querySelector('[data-nc-sort-hidden]').value = el.value;
        this.submitFilters();
        return;
      }
      if (this.form && this.form.contains(el) && el.type === 'checkbox') this.submitFilters();
    }

    onInput(e) {
      if (this.form && this.form.contains(e.target) && e.target.type === 'number') {
        clearTimeout(this.priceT);
        this.priceT = setTimeout(() => this.submitFilters(), 700);
      }
    }

    submitFilters() {
      const fd = new FormData(this.form);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) { if (k === 'nc_sort_m' || v === '') continue; params.append(k, v); }
      this.refresh(`${this.form.action}?${params.toString()}`);
    }

    /* ---------- AJAX refresh via Section Rendering API ---------- */
    async refresh(url, push = true) {
      const u = new URL(url, location.origin);
      u.searchParams.delete('page');
      const fetchUrl = new URL(u); fetchUrl.searchParams.set('section_id', this.sid);
      const wasOpen = this.drawer && this.drawer.classList.contains('is-on');
      const grid = this.querySelector('[data-nc-grid]');
      if (grid) grid.classList.add('is-loading');
      try {
        const html = await (await fetch(fetchUrl)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-nc-body]');
        if (!fresh) throw new Error('no body');
        const scrollY = window.scrollY;
        this.body.replaceWith(fresh);
        this.initBody();
        window.scrollTo(0, scrollY);
        if (wasOpen) { this.drawer.classList.add('is-on'); this.drawer.style.transition = 'none'; requestAnimationFrame(() => (this.drawer.style.transition = '')); }
        if (push) history.pushState({}, '', u.pathname + (u.search || ''));
      } catch (err) {
        location.href = u.toString();
      }
    }

    async loadMore(nextUrl, trigger) {
      if (!nextUrl || this.loading) return;
      this.loading = true;
      trigger && trigger.classList.add('is-loading');
      try {
        const u = new URL(nextUrl, location.origin); u.searchParams.set('section_id', this.sid);
        const doc = new DOMParser().parseFromString(await (await fetch(u)).text(), 'text/html');
        const grid = this.querySelector('[data-nc-grid]');
        doc.querySelectorAll('[data-nc-grid] > .nc-card').forEach((c) => grid.appendChild(c));
        const foot = doc.querySelector('[data-nc-foot]');
        if (foot) this.querySelector('[data-nc-foot]').replaceWith(foot);
        const shown = grid.querySelectorAll('.nc-card').length;
        const s = this.querySelector('[data-nc-shown]'); if (s) s.textContent = shown;
        this.observeSentinel(); this.observeFooter();
      } catch (e) {
        location.href = nextUrl;
      } finally { this.loading = false; trigger && trigger.classList.remove('is-loading'); }
    }

    syncArrows(track) {
      const media = track.parentElement;
      const prev = media.querySelector('.nc-arw--prev'), next = media.querySelector('.nc-arw--next');
      if (!prev || !next) return;
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    /* ---------- overlays ---------- */
    open(el) {
      if (!el) return;
      this.closeAll(true);
      this.scrim.hidden = false;
      el.hidden = false;
      requestAnimationFrame(() => { this.scrim.classList.add('is-on'); el.classList.add('is-on'); });
      document.documentElement.classList.add('nc-lock');
      this.lastFocus = document.activeElement;
      setTimeout(() => { const f = el.querySelector('button, a, input, select'); f && f.focus({ preventScroll: true }); }, 60);
    }
    closeAll(silent) {
      [this.drawer, this.modal, this.chat].forEach((el) => el && el.classList.remove('is-on'));
      this.scrim && this.scrim.classList.remove('is-on');
      document.documentElement.classList.remove('nc-lock');
      clearTimeout(this.typingT);
      if (!silent) setTimeout(() => {
        if (!this.querySelector('.is-on.nc-modal, .is-on.nc-chat')) { this.scrim.hidden = true; this.modal.hidden = true; if (this.chat) this.chat.hidden = true; }
      }, 400);
      if (!silent && this.lastFocus) this.lastFocus.focus({ preventScroll: true });
    }
    toast(html) {
      this.toastEl.innerHTML = html;
      this.toastEl.classList.add('is-on');
      clearTimeout(this.toastT);
      this.toastT = setTimeout(() => this.toastEl.classList.remove('is-on'), 3200);
    }

    /* ---------- quick view ---------- */
    async quickView(handle) {
      const L = this.labels;
      this.modal.querySelector('[data-nc-modal-body]').innerHTML = '<div class="nc-qv-c"><div class="nc-sent"><i></i></div></div>';
      this.open(this.modal);
      try {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const p = await (await fetch(`${root}products/${handle}.js`)).json();
        this.qvProduct = p;
        const sizeIdx = p.options.findIndex((o) => (o.name || o).toString().toLowerCase() === (L.size || 'Size').toLowerCase());
        const money = this.dataset.moneyFormat;
        const img = p.featured_image || '';
        let sizes = '';
        if (sizeIdx > -1 && p.variants.length > 1) {
          const opt = p.options[sizeIdx]; const values = opt.values || [];
          sizes = `<div class="nc-qv-lab"><span>${esc(L.size)}</span>${L.sizeGuideUrl ? `<a href="${esc(L.sizeGuideUrl)}">${esc(L.sizeGuide || 'Size guide')}</a>` : ''}</div>
            <div class="nc-qv-sizes">${values.map((v) => {
              const variant = p.variants.find((x) => x.options[sizeIdx] === v && x.available);
              return `<button type="button" data-nc-size data-variant="${variant ? variant.id : ''}" ${variant ? '' : 'disabled'}>${esc(v)}</button>`;
            }).join('')}</div>`;
        }
        const single = p.variants.length === 1 ? p.variants[0] : null;
        const perks = (L.perks || '').split('<br>').map((x) => x.trim()).filter(Boolean);
        this.modal.querySelector('[data-nc-modal-body]').innerHTML = `
          <div class="nc-qv-media">${img ? `<img src="${img.startsWith('data:') ? img : img + (img.includes('?') ? '&' : '?') + 'width=900'}" alt="${esc(p.title)}">` : ''}</div>
          <div class="nc-qv-c">
            ${p.type ? `<p class="nc-qv-kick">${esc(p.type)}</p>` : ''}
            <h3>${esc(p.title)}</h3>
            <p class="nc-qv-price">${p.compare_at_price > p.price ? `<s>${formatMoney(p.compare_at_price, money)}</s> ` : ''}${formatMoney(p.price, money)}</p>
            ${sizes}
            <p class="nc-qv-msg" data-nc-msg></p>
            <div class="nc-qv-acts">
              <button type="button" class="nc-btn nc-btn--solid" data-nc-add data-variant="${single && single.available ? single.id : ''}" ${p.available ? '' : 'disabled'}>${esc(p.available ? L.add : L.soldout)}</button>
              ${L.showStylist ? `<button type="button" class="nc-btn" data-nc-chat="${esc(p.title)}">${this.waIcon()}<span class="nc-btn__l">${L.stylist}</span></button>` : ''}
            </div>
            <ul class="nc-qv-perks">${perks.map((x) => `<li>${x}</li>`).join('')}<li><a href="${p.url}">${esc(L.details)}</a></li></ul>
          </div>`;
      } catch (e) {
        this.modal.querySelector('[data-nc-modal-body]').innerHTML = `<div class="nc-qv-c"><p>${esc(L.error)}</p></div>`;
      }
    }
    pickSize(btn) {
      btn.parentElement.querySelectorAll('button').forEach((b) => b.classList.remove('is-on'));
      btn.classList.add('is-on');
      const add = this.modal.querySelector('[data-nc-add]'); add.dataset.variant = btn.dataset.variant;
      const msg = this.modal.querySelector('[data-nc-msg]'); if (msg) msg.textContent = '';
    }
    async addToCart(btn) {
      const L = this.labels;
      const id = btn.dataset.variant;
      if (!id) { const msg = this.modal.querySelector('[data-nc-msg]'); if (msg) msg.textContent = L.select; return; }
      btn.setAttribute('aria-disabled', 'true');
      try {
        const res = await fetch(`${this.dataset.cartAddUrl}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
        if (!res.ok) throw new Error((await res.json()).description || 'error');
        const cart = await (await fetch(`${this.dataset.cartUrl}.js`)).json();
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden], .cart-count, #CartCount, .header__cart-count').forEach((el) => (el.textContent = cart.item_count));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('nc:cart-added', { detail: { cart }, bubbles: true }));
        this.closeAll();
        this.toast(`<span>${esc(L.added)}</span><a href="${this.dataset.cartUrl}">${esc(L.viewBag)}</a>`);
      } catch (e) {
        const msg = this.modal.querySelector('[data-nc-msg]'); if (msg) msg.textContent = e.message || L.error;
      } finally { btn.removeAttribute('aria-disabled'); }
    }

    /* ---------- stylist chat ---------- */
    waIcon() { return '<svg class="nc-ic nc-ic--fill" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.2A9.8 9.8 0 003.6 17l-1.3 4.8 4.9-1.3A9.8 9.8 0 1012 2.2zm0 17.9a8.1 8.1 0 01-4.1-1.1l-.3-.2-2.9.8.8-2.8-.2-.3A8.1 8.1 0 1112 20.1zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.6.8-.8 1-.3.2-.5.1a6.6 6.6 0 01-3.3-2.9c-.2-.4.2-.4.7-1.3a.4.4 0 000-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 00-.7.3 3 3 0 00-.9 2.2 5.2 5.2 0 001.1 2.8 11.9 11.9 0 004.6 4c1.7.7 2.4.8 3.2.7a2.8 2.8 0 001.8-1.3 2.3 2.3 0 00.2-1.3c-.1-.1-.3-.2-.5-.3z"/></svg>'; }
    openChat(product) {
      const c = this.chat; if (!c) return;
      const coll = c.dataset.collection || '';
      const msg = clean(c.dataset.prefill)
        .replace(/\[product\]/gi, product || (coll ? `the ${coll} collection` : 'this collection'))
        .replace(/\[collection\]/gi, coll);
      const link = `https://wa.me/${c.dataset.phone}${msg ? `?text=${encodeURIComponent(msg)}` : ''}`;
      c.querySelector('[data-nc-wa]').href = link;
      const out = c.querySelector('[data-nc-out]');
      if (msg) { out.hidden = false; c.querySelector('[data-nc-out-text]').textContent = msg; } else out.hidden = true;
      const typing = c.querySelector('[data-nc-typing]'), reply = c.querySelector('[data-nc-reply]');
      if (reply) {
        typing.hidden = false; reply.hidden = true;
        c.querySelector('[data-nc-time]').textContent = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        clearTimeout(this.typingT);
        this.typingT = setTimeout(() => { typing.hidden = true; reply.hidden = false; }, 1200);
      }
      this.open(c);
    }
  }
  customElements.define('nc-collection', NcCollection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-product"] && !Shopify.designMode) return;
  try {
    
/* House of Nitka — business-day delivery estimate (shared) */
window.HNDelivery = window.HNDelivery || (function(){
  function parts(tz){
    var p = {}, now = new Date();
    try {
      new Intl.DateTimeFormat('en-US',{timeZone:tz||undefined,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'})
        .formatToParts(now).forEach(function(x){ p[x.type] = x.value; });
    } catch(e) {
      p = {year:now.getFullYear(),month:now.getMonth()+1,day:now.getDate(),hour:now.getHours(),minute:now.getMinutes(),second:now.getSeconds()};
    }
    return p;
  }
  function calc(c, p){
    var off = typeof c.off === 'string' ? c.off.split(',').filter(function(x){return x!=='';}).map(Number) : (c.off || []);
    var hol = typeof c.hol === 'string' ? (c.hol.match(/\d{4}-\d{2}-\d{2}/g) || []) : (c.hol || []);
    var today = new Date(Date.UTC(+p.year, +p.month-1, +p.day));
    var secs = (+p.hour % 24)*3600 + (+p.minute)*60 + (+p.second);
    var ct = String(c.cutoff || '14:00').split(':');
    var cutS = (+ct[0])*3600 + (+(ct[1]||0))*60;
    function iso(d){ return d.toISOString().slice(0,10); }
    function biz(d){ return off.indexOf(d.getUTCDay()) < 0 && hol.indexOf(iso(d)) < 0; }
    function next(d){ var x = new Date(d.getTime()); do { x.setUTCDate(x.getUTCDate()+1); } while(!biz(x)); return x; }
    var beforeCut = biz(today) && secs < cutS;
    var ship = beforeCut ? today : next(today), i;
    for(i=0;i<(+c.proc||0);i++) ship = next(ship);
    var a = ship; for(i=0;i<(+c.min||0);i++) a = next(a);
    var b = ship; for(i=0;i<Math.max(+c.max||0,+c.min||0);i++) b = next(b);
    return {today:today, ship:ship, a:a, b:b, beforeCut:beforeCut, left:cutS-secs};
  }
  function fmt(d, c){
    var o = {timeZone:'UTC'};
    if(c.fmt === 'wdm'){ o.weekday='short'; o.day='numeric'; o.month='short'; }
    else if(c.fmt === 'long'){ o.weekday='long'; o.day='numeric'; o.month='long'; }
    else if(c.fmt === 'md'){ o.month='short'; o.day='numeric'; }
    else { o.day='numeric'; o.month='short'; }
    var loc = c.fmt === 'md' ? 'en-US' : (c.loc || 'en-GB');
    try { return new Intl.DateTimeFormat(loc, o).format(d).replace(/,/g,''); } catch(e){ return d.toISOString().slice(0,10); }
  }
  function fill(t, r, c){
    var lo = (+c.proc||0) + (+c.min||0), hi = (+c.proc||0) + Math.max(+c.max||0, +c.min||0);
    var days = lo === hi ? lo + ' ' + (lo === 1 ? c.one : c.many) : lo + '–' + hi + ' ' + c.many;
    var date = r.a.getTime() === r.b.getTime() ? fmt(r.a, c) : fmt(r.a, c) + ' – ' + fmt(r.b, c);
    var h = Math.floor(r.left/3600), m = Math.floor((r.left%3600)/60);
    var cd = h ? h + 'h' + (m ? ' ' + m + 'm' : '') : m + 'm';
    var diff = Math.round((r.ship - r.today)/864e5);
    var shipTxt = diff === 0 ? c.today : diff === 1 ? c.tomorrow : (function(){ try { return new Intl.DateTimeFormat(c.loc||'en-GB',{weekday:'long',timeZone:'UTC'}).format(r.ship); } catch(e){ return ''; } })();
    return String(t||'').replace(/\{days\}/g, days).replace(/\{date\}/g, date).replace(/\{start\}/g, fmt(r.a,c)).replace(/\{end\}/g, fmt(r.b,c)).replace(/\{countdown\}/g, cd).replace(/\{ship\}/g, shipTxt);
  }
  function run(el){
    var c; try { c = JSON.parse(el.getAttribute('data-hn-delivery')); } catch(e){ return; }
    var r = calc(c, parts(c.tz));
    var t1 = el.querySelector('[data-d-title]'), t2 = el.querySelector('[data-d-sub]');
    if(t1) t1.textContent = fill(c.t1, r, c);
    if(t2){ var s = fill(r.beforeCut && r.ship.getTime() === r.today.getTime() ? c.t2 : c.t2late, r, c); t2.textContent = s; t2.hidden = !s; }
    el.classList.add('is-ready');
  }
  function initAll(scope){
    (scope||document).querySelectorAll('[data-hn-delivery]').forEach(function(el){
      run(el);
      if(!el._hnT) el._hnT = setInterval(function(){ run(el); }, 30000);
    });
  }
  return {calc:calc, fill:fill, run:run, initAll:initAll};
})();
(function(){
  if(document.readyState !== 'loading') HNDelivery.initAll(); else document.addEventListener('DOMContentLoaded', function(){ HNDelivery.initAll(); });
  document.addEventListener('shopify:section:load', function(e){ HNDelivery.initAll(e.target); });
  document.addEventListener('shopify:block:select', function(e){ HNDelivery.initAll(e.target.closest('.shopify-section')||document); });
})();
(function(){
  function fmtN(c,d,t,s){var x=(c/100).toFixed(d).split('.');x[0]=x[0].replace(/\B(?=(\d{3})+(?!\d))/g,t);return d?x[0]+s+x[1]:x[0];}
  function money(c,f){
    c=Math.round(c||0);f=f||('$'+'{'+'{amount}'+'}');
    var m=f.match(/\{\{\s*(\w+)\s*\}\}/),k=m?m[1]:'amount';
    var map={amount:fmtN(c,2,',','.'),amount_no_decimals:fmtN(c,0,',','.'),amount_with_comma_separator:fmtN(c,2,'.',','),amount_no_decimals_with_comma_separator:fmtN(c,0,'.',','),amount_with_space_separator:fmtN(c,2,' ',','),amount_no_decimals_with_space_separator:fmtN(c,0,' ',','),amount_with_apostrophe_separator:fmtN(c,2,"'",'.')};
    var t=document.createElement('textarea');t.innerHTML=f.replace(/\{\{\s*\w+\s*\}\}/,map[k]||map.amount);return t.value.replace(/<[^>]*>/g,'');
  }
  function short(s){return s.replace(/([.,])00(?!\d)/,'');}

  function init(root){
    if(!root||root.dataset.hnReady)return;root.dataset.hnReady='1';
    var P,C;try{P=JSON.parse(root.querySelector('[data-product]').textContent);C=JSON.parse(root.querySelector('[data-cfg]').textContent);}catch(e){return;}
    var $=function(q){return root.querySelector(q);},$$=function(q){return [].slice.call(root.querySelectorAll(q));};
    var form=$('form.hn-pp__form'),vid=$('[data-vid]'),addBtn=$('[data-add]'),addLbl=$('[data-add-label]'),err=$('[data-err]'),optsBox=$('[data-opts]');
    var cur=P.variants.filter(function(v){return vid&&String(v.id)===vid.value;})[0]||P.variants[0];
    var fs=$$('[data-opt]'),sizeIdx=-1,sel=cur.options.slice();
    fs.forEach(function(f){var i=+f.dataset.opt,on=f.querySelector('.hn-pp__val.is-on');if(f.classList.contains('is-size'))sizeIdx=i;sel[i]=on?on.dataset.val:null;var l=f.querySelector('[data-opt-val]');if(l)l.dataset.ph=on?'':l.textContent;});
    var cs=$('[data-cs]'),custom=false,customVal=null;
    var cb=$('.hn-pp__val.is-custom');if(cb)customVal=cb.dataset.val;

    function match(v,skip){return v.options.every(function(o,j){return j===skip||sel[j]==null||sel[j]===o;});}
    function findV(){
      var exact=P.variants.filter(function(v){return v.options.every(function(o,j){return sel[j]===o;});})[0];
      if(exact)return exact;
      if(custom&&sizeIdx>-1&&sel[sizeIdx]==null)return P.variants.filter(function(v){return v.available&&match(v,sizeIdx);})[0]||P.variants.filter(function(v){return match(v,sizeIdx);})[0];
      return null;
    }
    function missing(){return sel.some(function(x,i){return x==null&&!(custom&&i===sizeIdx);});}
    function setLabel(t,dis){if(addLbl)addLbl.textContent=t;if(addBtn)addBtn.disabled=!!dis;var sl=$('[data-sb-label]');if(sl)sl.textContent=t;}

    function update(user){
      fs.forEach(function(f){
        var i=+f.dataset.opt;
        f.querySelectorAll('[data-val]').forEach(function(b){
          var val=b.dataset.val,ok=P.variants.some(function(x){return x.available&&x.options[i]===val&&match(x,i);});
          b.classList.toggle('is-out',!ok);b.classList.toggle('is-on',sel[i]===val&&!b.hidden);b.setAttribute('aria-pressed',sel[i]===val?'true':'false');
        });
        var l=f.querySelector('[data-opt-val]');if(l)l.textContent=(sel[i]&&!(custom&&i===sizeIdx))?sel[i]:(custom&&i===sizeIdx?(cs&&cs.dataset.label||''):l.dataset.ph||'');
      });
      var v=findV();
      if(v){
        cur=v;if(vid)vid.value=v.id;
        var pe=$('[data-price]'),cf=$('[data-cur-fmt]');
        if(pe)pe.textContent=money(v.price,cf&&cf.textContent.trim()==='true'?C.moneyC:C.money);
        var ce=$('[data-compare]');if(ce){ce.hidden=!(v.compare_at_price>v.price);ce.textContent=money(v.compare_at_price,C.money);}
        var sp=$('[data-sb-price]');if(sp)sp.textContent=money(v.price,C.money);
        $$('[data-tabby]').forEach(function(t){var n=+t.dataset.n||4,a=Math.floor(v.price/n),s=money(a,C.money);if(t.dataset.fmt!=='full')s=short(s);var el=t.querySelector('[data-tabby-amt]');if(el)el.textContent=s;var mn=+t.dataset.min||0,mx=+t.dataset.max||0;t.hidden=v.price<mn||(mx>0&&v.price>mx);});
        if(user&&root.dataset.updateUrl==='true'&&!missing()){try{history.replaceState(history.state,'',root.dataset.url+'?variant='+v.id);}catch(e){}}
        if(user&&root.dataset.jump==='true'&&v.featured_media)goMedia(v.featured_media.id);
        root.dispatchEvent(new CustomEvent('hn:variant',{bubbles:true,detail:{variant:v}}));
      }
      if(missing())setLabel(C.pickLabel,false);
      else if(!v||!v.available)setLabel(C.soldLabel,true);
      else setLabel(C.addLabel,false);
      if(err&&!missing())err.hidden=true;
    }

    fs.forEach(function(f){f.addEventListener('click',function(e){
      var b=e.target.closest('[data-val]');if(!b)return;var i=+f.dataset.opt;
      sel[i]=b.dataset.val;
      if(i===sizeIdx&&cs&&cs.open){cs.open=false;}
      update(true);
    });});

    if(cs){
      cs.dataset.label=(cs.querySelector('summary .hn-pp__lbl')||{}).firstChild?cs.querySelector('summary .hn-pp__lbl').firstChild.textContent.trim():'';
      cs.addEventListener('toggle',function(){
        custom=cs.open;cs.querySelectorAll('[data-cs-input]').forEach(function(x){x.disabled=!custom;});
        if(sizeIdx>-1){sel[sizeIdx]=custom?(customVal||null):null;}
        update(true);
      });
    }

    function showErr(msg){if(!err)return;err.textContent=msg;err.hidden=false;if(optsBox){optsBox.classList.remove('is-shake');void optsBox.offsetWidth;optsBox.classList.add('is-shake');var r=optsBox.getBoundingClientRect();if(r.top<0||r.top>innerHeight*.7)window.scrollTo({top:scrollY+r.top-100,behavior:'smooth'});}}
    function validCustom(){
      if(!custom)return true;
      var bad=[].slice.call(cs.querySelectorAll('input[type=text][data-cs-input]')).filter(function(x){return !x.value.trim();});
      bad.forEach(function(x){x.style.borderColor='var(--pp-error)';x.addEventListener('input',function(){x.style.borderColor='';},{once:true});});
      if(bad.length){bad[0].focus();return false;}return true;
    }
    if(form)form.addEventListener('submit',function(e){
      if(missing()){e.preventDefault();showErr(C.msgPick);return;}
      if(!validCustom()){e.preventDefault();return;}
      var mode=root.dataset.cart;if(mode==='page')return;
      e.preventDefault();addBtn.classList.add('is-busy');
      var fd=new FormData(form);
      fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd})
        .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
        .then(function(res){
          addBtn.classList.remove('is-busy');
          if(!res.ok){showErr(res.j.description||res.j.message||'Error');return;}
          ['cart:refresh','cart:updated','cart:change','theme:cart:change'].forEach(function(n){document.dispatchEvent(new CustomEvent(n,{bubbles:true,detail:{item:res.j}}));});
          fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart.js').then(function(r){return r.json();}).then(function(c){document.querySelectorAll('[data-cart-count],.cart-count-bubble span:first-child,.cart-count').forEach(function(n){n.textContent=c.item_count;});});
          if(mode==='drawer'){var t=root.dataset.cartSelector&&document.querySelector(root.dataset.cartSelector);if(t)t.click();else location.href=root.dataset.cartUrl;}
          else{setLabel(C.addedLabel,false);setTimeout(function(){update(false);},2200);}
        }).catch(function(){addBtn.classList.remove('is-busy');form.submit();});
    });

    /* chat button message */
    $$('[data-chat]').forEach(function(a){a.addEventListener('click',function(){
      var size=custom?(cs&&cs.dataset.label||''):(sizeIdx>-1&&sel[sizeIdx]||'');
      var m=(a.dataset.msg||'').replace(/\{product\}/g,P.title).replace(/\{size\}/g,size).replace(/\{url\}/g,location.origin+root.dataset.url);
      a.href='https://wa.me/'+a.dataset.phone+(m?'?text='+encodeURIComponent(m):'');
    });});

    /* gallery */
    var gal=$('[data-gal]'),slides=$$('.hn-pp__m'),dots=$$('[data-go]'),count=$('[data-cur]'),arrs=$$('[data-step]'),idx=0;
    var mq=window.matchMedia('(max-width: 999px)');
    function near(){var best=0,d=1e9,c=gal.scrollLeft+gal.clientWidth/2;slides.forEach(function(s,i){var m=s.offsetLeft+s.offsetWidth/2,x=Math.abs(m-c);if(x<d){d=x;best=i;}});return best;}
    function paint(){dots.forEach(function(d,i){d.classList.toggle('is-on',i===idx);});if(count)count.textContent=idx+1;if(arrs.length){arrs[0].disabled=idx<=0;arrs[1].disabled=idx>=slides.length-1;}
      var th=$('.hn-pp__thumbs'),on=th&&th.children[idx];if(on)th.scrollTo({left:on.offsetLeft-th.clientWidth/2+on.offsetWidth/2,behavior:'smooth'});}
    function go(i){if(!gal||!slides[i])return;idx=i;var s=slides[i];gal.scrollTo({left:s.offsetLeft-(gal.clientWidth-s.offsetWidth)/2,behavior:'smooth'});paint();}
    function goMedia(id){var i=slides.map(function(s){return s.dataset.mediaId;}).indexOf(String(id));if(i<0)return;
      if(mq.matches)go(i);else if(i>0){gal.prepend(slides[i]);slides=$$('.hn-pp__m');}}
    if(gal){
      var tm;gal.addEventListener('scroll',function(){clearTimeout(tm);tm=setTimeout(function(){if(mq.matches){idx=near();paint();}},60);},{passive:true});
      dots.forEach(function(d){d.addEventListener('click',function(){go(+d.dataset.go);});});
      arrs.forEach(function(a){a.addEventListener('click',function(){go(Math.max(0,Math.min(slides.length-1,idx+ +a.dataset.step)));});});
      paint();
    }
    var more=$('[data-more]');if(more)more.addEventListener('click',function(){gal.classList.add('is-all');});

    /* photo viewer */
    var lb=$('[data-lb]');
    if(lb){
      var tr=lb.querySelector('[data-lb-track]'),ls=[].slice.call(lb.querySelectorAll('.hn-pp__lb-slide'));
      root.addEventListener('click',function(e){var z=e.target.closest('[data-zoom]');if(!z)return;var i=+z.dataset.zoom,k=ls.map(function(s){return +s.dataset.mediaI;}).indexOf(i);
        if(typeof lb.showModal==='function')lb.showModal();else lb.setAttribute('open','');document.documentElement.style.overflow='hidden';
        requestAnimationFrame(function(){tr.scrollTo({left:Math.max(k,0)*tr.clientWidth,behavior:'instant'});});});
      lb.querySelectorAll('[data-lb-step]').forEach(function(b){b.addEventListener('click',function(){tr.scrollBy({left:tr.clientWidth*+b.dataset.lbStep,behavior:'smooth'});});});
      ls.forEach(function(s){s.addEventListener('click',function(e){if(e.target.tagName==='IMG')s.classList.toggle('is-zoom');});});
      lb.addEventListener('close',function(){document.documentElement.style.overflow='';ls.forEach(function(s){s.classList.remove('is-zoom');});});
      lb.querySelector('[data-close]').addEventListener('click',function(){lb.close();});
    }

    /* size guide */
    var gd=$('[data-guide]');
    if(gd){
      $$('[data-open-guide]').forEach(function(b){b.addEventListener('click',function(){gd.showModal();document.documentElement.style.overflow='hidden';});});
      gd.addEventListener('click',function(e){if(e.target===gd||e.target.closest('[data-close]'))gd.close();});
      gd.addEventListener('close',function(){document.documentElement.style.overflow='';});
    }

    /* description */
    $$('[data-read]').forEach(function(b){b.addEventListener('click',function(){b.closest('[data-desc]').classList.add('is-open');});});

    /* sticky bar */
    var sb=$('[data-sb]');
    if(sb&&addBtn){
      var ticking=false;
      var chk=function(){ticking=false;if(!mq.matches){sb.classList.remove('is-on');return;}var r=addBtn.getBoundingClientRect();var on=r.bottom<0;sb.classList.toggle('is-on',on);sb.setAttribute('aria-hidden',on?'false':'true');};
      window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(chk);}},{passive:true});
      window.addEventListener('resize',chk);chk();
      sb.querySelector('[data-sb-btn]').addEventListener('click',function(){
        if(missing()){showErr(C.msgPick);return;}
        if(form.requestSubmit)form.requestSubmit(addBtn);else addBtn.click();
      });
    }
    update(false);
  }
  function all(){document.querySelectorAll('[data-hn-pp]').forEach(init);}
  if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[data-hn-pp]'));});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-top-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.dataset.hnReady)return;root.dataset.hnReady='1';
    var m=root.querySelectorAll('.hn-tb__msg');if(m.length<2)return;
    var i=0,ms=Math.max(2,parseInt(root.dataset.speed||5,10))*1000;
    setInterval(function(){m[i].classList.remove('is-on');i=(i+1)%m.length;m[i].classList.add('is-on');},ms);
  }
  function all(){document.querySelectorAll('[data-hn-tb]').forEach(init);}
  if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[data-hn-tb]'));});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
(function(){
  function arrows(root){
    var t=root.querySelector('[data-track]'),b=root.querySelectorAll('.hn-rl__arr');if(!t||!b.length)return;
    function upd(){var max=t.scrollWidth-t.clientWidth-2;b[0].disabled=t.scrollLeft<=2;b[1].disabled=t.scrollLeft>=max;}
    b.forEach(function(x){x.onclick=function(){var c=t.querySelector('.hn-rl__card');var w=c?c.getBoundingClientRect().width+parseFloat(getComputedStyle(t).columnGap||0):t.clientWidth;t.scrollBy({left:w*parseInt(x.dataset.dir,10),behavior:'smooth'});};});
    t.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();
  }
  function init(root){
    if(!root||root.dataset.hnReady)return;root.dataset.hnReady='1';
    var url=root.dataset.url;
    if(!url){if(!root.querySelector('.hn-rl__card'))root.classList.add('is-empty');arrows(root);return;}
    fetch(url).then(function(r){return r.text();}).then(function(h){
      var d=new DOMParser().parseFromString(h,'text/html');var n=d.querySelector('[data-hn-rl] [data-track]');var t=root.querySelector('[data-track]');
      if(n&&n.children.length){t.innerHTML=n.innerHTML;}else{root.classList.add('is-empty');}
      arrows(root);
    }).catch(function(){root.classList.add('is-empty');});
  }
  function all(){document.querySelectorAll('[data-hn-rl]').forEach(init);}
  if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[data-hn-rl]'));});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-badges"] && !Shopify.designMode) return;
  try {
    
/* House of Nitka — business-day delivery estimate (shared) */
window.HNDelivery = window.HNDelivery || (function(){
  function parts(tz){
    var p = {}, now = new Date();
    try {
      new Intl.DateTimeFormat('en-US',{timeZone:tz||undefined,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'})
        .formatToParts(now).forEach(function(x){ p[x.type] = x.value; });
    } catch(e) {
      p = {year:now.getFullYear(),month:now.getMonth()+1,day:now.getDate(),hour:now.getHours(),minute:now.getMinutes(),second:now.getSeconds()};
    }
    return p;
  }
  function calc(c, p){
    var off = typeof c.off === 'string' ? c.off.split(',').filter(function(x){return x!=='';}).map(Number) : (c.off || []);
    var hol = typeof c.hol === 'string' ? (c.hol.match(/\d{4}-\d{2}-\d{2}/g) || []) : (c.hol || []);
    var today = new Date(Date.UTC(+p.year, +p.month-1, +p.day));
    var secs = (+p.hour % 24)*3600 + (+p.minute)*60 + (+p.second);
    var ct = String(c.cutoff || '14:00').split(':');
    var cutS = (+ct[0])*3600 + (+(ct[1]||0))*60;
    function iso(d){ return d.toISOString().slice(0,10); }
    function biz(d){ return off.indexOf(d.getUTCDay()) < 0 && hol.indexOf(iso(d)) < 0; }
    function next(d){ var x = new Date(d.getTime()); do { x.setUTCDate(x.getUTCDate()+1); } while(!biz(x)); return x; }
    var beforeCut = biz(today) && secs < cutS;
    var ship = beforeCut ? today : next(today), i;
    for(i=0;i<(+c.proc||0);i++) ship = next(ship);
    var a = ship; for(i=0;i<(+c.min||0);i++) a = next(a);
    var b = ship; for(i=0;i<Math.max(+c.max||0,+c.min||0);i++) b = next(b);
    return {today:today, ship:ship, a:a, b:b, beforeCut:beforeCut, left:cutS-secs};
  }
  function fmt(d, c){
    var o = {timeZone:'UTC'};
    if(c.fmt === 'wdm'){ o.weekday='short'; o.day='numeric'; o.month='short'; }
    else if(c.fmt === 'long'){ o.weekday='long'; o.day='numeric'; o.month='long'; }
    else if(c.fmt === 'md'){ o.month='short'; o.day='numeric'; }
    else { o.day='numeric'; o.month='short'; }
    var loc = c.fmt === 'md' ? 'en-US' : (c.loc || 'en-GB');
    try { return new Intl.DateTimeFormat(loc, o).format(d).replace(/,/g,''); } catch(e){ return d.toISOString().slice(0,10); }
  }
  function fill(t, r, c){
    var lo = (+c.proc||0) + (+c.min||0), hi = (+c.proc||0) + Math.max(+c.max||0, +c.min||0);
    var days = lo === hi ? lo + ' ' + (lo === 1 ? c.one : c.many) : lo + '–' + hi + ' ' + c.many;
    var date = r.a.getTime() === r.b.getTime() ? fmt(r.a, c) : fmt(r.a, c) + ' – ' + fmt(r.b, c);
    var h = Math.floor(r.left/3600), m = Math.floor((r.left%3600)/60);
    var cd = h ? h + 'h' + (m ? ' ' + m + 'm' : '') : m + 'm';
    var diff = Math.round((r.ship - r.today)/864e5);
    var shipTxt = diff === 0 ? c.today : diff === 1 ? c.tomorrow : (function(){ try { return new Intl.DateTimeFormat(c.loc||'en-GB',{weekday:'long',timeZone:'UTC'}).format(r.ship); } catch(e){ return ''; } })();
    return String(t||'').replace(/\{days\}/g, days).replace(/\{date\}/g, date).replace(/\{start\}/g, fmt(r.a,c)).replace(/\{end\}/g, fmt(r.b,c)).replace(/\{countdown\}/g, cd).replace(/\{ship\}/g, shipTxt);
  }
  function run(el){
    var c; try { c = JSON.parse(el.getAttribute('data-hn-delivery')); } catch(e){ return; }
    var r = calc(c, parts(c.tz));
    var t1 = el.querySelector('[data-d-title]'), t2 = el.querySelector('[data-d-sub]');
    if(t1) t1.textContent = fill(c.t1, r, c);
    if(t2){ var s = fill(r.beforeCut && r.ship.getTime() === r.today.getTime() ? c.t2 : c.t2late, r, c); t2.textContent = s; t2.hidden = !s; }
    el.classList.add('is-ready');
  }
  function initAll(scope){
    (scope||document).querySelectorAll('[data-hn-delivery]').forEach(function(el){
      run(el);
      if(!el._hnT) el._hnT = setInterval(function(){ run(el); }, 30000);
    });
  }
  return {calc:calc, fill:fill, run:run, initAll:initAll};
})();
(function(){
  if(document.readyState !== 'loading') HNDelivery.initAll(); else document.addEventListener('DOMContentLoaded', function(){ HNDelivery.initAll(); });
  document.addEventListener('shopify:section:load', function(e){ HNDelivery.initAll(e.target); });
  document.addEventListener('shopify:block:select', function(e){ HNDelivery.initAll(e.target.closest('.shopify-section')||document); });
})();

  } catch(e) { console.error(e); }
})();
})();
